import { useContext } from "react";

import { useMuxSpecificationApi } from "../../../../../common/api/orders-api/mux-specification/useMuxSpecificationApi";
import { MuxerType } from "../../../../../common/types/MuxerType";
import { EncodeSpecificationType } from "../../../../encode-specification/context/EncodeSpecificationItem";
import { MuxSpecificationListingContext } from "../../../context/MuxSpecificationListingContext";
import { EditGpacMuxSpecificationFormInputs } from "./EditGpacMuxSpecificationForm";

export const useEditGpacMuxSpecificationForm = () => {
    const { updateGpacMuxSpecification, getMuxSpecificationById } = useMuxSpecificationApi();
    const { update: updateGpacMuxSpecificationInContext } = useContext(MuxSpecificationListingContext);

    const editGpacMuxSpecification = async (itemId: string, inputs: EditGpacMuxSpecificationFormInputs) => {
        const name = inputs.name;
        const command = inputs.command;
        const soundtracksCommand = inputs.soundtracksCommand;
        const subtitlesCommand = inputs.soundtracksCommand;
        await updateGpacMuxSpecification({
            id: itemId,
            name: inputs.name,
            command: inputs.command,
            soundtracksCommand: inputs.soundtracksCommand,
            subtitlesCommand: inputs.subtitlesCommand
        });

        updateGpacMuxSpecificationInContext({
            id: itemId,
            name,
            type: MuxerType.GPAC,
            details: {
                type: MuxerType.GPAC,
                command,
                soundtracksCommand,
                subtitlesCommand
            },
            encodeSpecificationType: EncodeSpecificationType.MPEG_4,
            updatedDate: new Date().toISOString(),
            isModified: true
        });
    };

    return {
        editGpacMuxSpecification,
        getMuxSpecificationById
    };
};
